module.exports = __webpack_public_path__ + "static/media/dual-circle.3b0a2d2a.png";